import { hasOwn } from '@/utils/util';

export function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
};



// WEBPACK FOOTER //
// ./src/utils/vdom.js